import Exception from "src/utils/exception";
import Constants from "src/utils/constants";
import DBOperationsComb from "src/utils/dbOperationsComb";
import Helper from "src/utils/helper";

async function getEmailTemplateById(id, offlineFirst = true) {
  try {
    if(!Helper.isStringValueExist(id)) {
      return { error: "Email template ID is required", data: null };
    }
    return await DBOperationsComb.getData(
      Constants.enums.TABLES_NAME_ENUM.EMAIL_TEMPLATES_TABLE,
      id,
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  getEmailTemplateById
};
